import { persistentReducedStream } from '@ardoq/rxbeach';
import { reducers } from './reducers';
import { getDefaultFilterConditionState } from 'broadcasts/utils';
import { combineLatest, map } from 'rxjs';
import { i18nLocale$ } from 'streams/i18nLocale$';

const filterConditionsSection$ = persistentReducedStream(
  'filterConditionsSection$',
  getDefaultFilterConditionState(),
  reducers
);

export const filterConditionsSectionViewModel$ = combineLatest([
  filterConditionsSection$,
  i18nLocale$,
]).pipe(map(([state, i18nLocale]) => ({ ...state, i18nLocale })));

export { filterConditionsSection$ };
